import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { YEAR_FILTER_NONE, YearFilterSelectComponent } from '../year-filter-select/year-filter-select.component';

export interface YearRange {
  // null = Any (no limit on that side)
  from: number | null;
  to: number | null;
}

// From / To year filters. Each side holds Any or a year; each list hides years that would put From after To.
@Component({
  selector: 'app-year-range-filter',
  templateUrl: './year-range-filter.component.html',
  styleUrls: ['./year-range-filter.component.scss'],
  imports: [YearFilterSelectComponent]
})
export class YearRangeFilterComponent {

  @Input() form: FormGroup;
  @Input() fromControlName = 'year-from';
  @Input() toControlName = 'year-to';
  @Input() fromLabel = 'From';
  @Input() toLabel = 'To';
  @Input() anyLabel = 'Any';
  @Input() minYear = 2019;
  @Input() maxYear = new Date().getFullYear();
  @Input() maxYearAddition = 2;

  @Output() valueChanged = new EventEmitter<YearRange>();

  @ViewChild('fromYear', { static: true }) fromComp: YearFilterSelectComponent;
  @ViewChild('toYear', { static: true }) toComp: YearFilterSelectComponent;

  fromOmit: number[] = [];
  toOmit: number[] = [];

  value(): YearRange {
    return { from: this.fromComp.year(), to: this.toComp.year() };
  }

  reset() {
    this.fromComp.setValue(YEAR_FILTER_NONE);
    this.toComp.setValue(YEAR_FILTER_NONE);
    this.updateOmits();
  }

  onYearChange() {
    this.updateOmits();
    this.valueChanged.emit(this.value());
  }

  private updateOmits() {
    const { from, to } = this.value();
    const lastYear = this.maxYear + this.maxYearAddition;

    this.toOmit = from ? years(this.minYear, from - 1) : [];
    this.fromOmit = to ? years(to + 1, lastYear) : [];
  }
}

const years = (low: number, high: number) => Array.from({ length: Math.max(high - low + 1, 0) }, (_, i) => low + i);
